/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { Metadata } from "next";

import { ErrorTestPage } from "./ErrorTestPage.client";

export const metadata: Metadata = {
	title: "Error Test Page",
	robots: {
		index: false,
		follow: false,
	},
};

export default function CosmosErrorTestPage(): React.JSX.Element {
	return <ErrorTestPage />;
}
